import { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Process from "@/components/Process";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Boundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-ink text-cream flex items-center justify-center p-8">
          <p className="font-display text-2xl text-gold italic">Something went wrong — refresh to try again.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <div className="relative min-h-screen bg-ink text-cream">
            <div aria-hidden className="grain" />
            <Nav />
            <main>
              <Hero />
              <Marquee />
              <Services />
              <Portfolio />
              <Process />
              <Contact />
            </main>
            <Footer />
            <Toaster
              position="bottom-center"
              toastOptions={{
                style: {
                  background: "#141414",
                  border: "1px solid rgba(212, 175, 55, 0.35)",
                  color: "#F5F5F0",
                  fontFamily: "Outfit, sans-serif",
                },
              }}
            />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
